import { FC, memo, useCallback } from 'react'
import { components, OptionTypeBase, SingleValueProps } from 'react-select'
import styled from 'styled-components'

import { FlexDiv, FlexDivCol } from 'components/layout/flex'
import Select from 'components/Select'

import { IndicatorSeparator, DropdownIndicator } from '../../../components/Select'

type DropdownFilterProps = {
	name: 'asset' | 'network' | 'side' | 'status' | 'type'
	options: DropdownValue[]
	onChange: (name: string, value: DropdownValue) => void
	value?: string | null
	isSearchable?: boolean
}

export type DropdownValue = {
	value: string
	label: string
}

const CustomSingleValue: React.FC<SingleValueProps<OptionTypeBase>> = ({ children, ...props }) => {
	return (
		<SelectedValueContainer {...props}>
			<DropdownName>{props.selectProps.name} </DropdownName> {children}
		</SelectedValueContainer>
	)
}

const SelectedValueContainer = styled(components.SingleValue)`
	display: flex;
	width: 100%;
	padding-right: 10px;
	justify-content: space-between;
`

const DropdownName = styled.span`
	text-transform: capitalize;
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.secondary};
`

const DropdownFilter: FC<DropdownFilterProps> = memo(
	({ onChange, value, isSearchable = false, options, name }) => {
		const formatOptionLabel = ({ label }: any) => {
			return <StyledLabelContainer>{label}</StyledLabelContainer>
		}

		const getSelectValue = useCallback(
			(value?: string | null) => {
				const defaultValue = { value: 'all', label: 'All' }
				if (!value) return defaultValue
				const selectedOptions = options.find((option) => option.value === value)
				return selectedOptions || defaultValue
			},
			[options]
		)

		return (
			<DropDownContainer>
				<StyledNetworkSelect
					name={name}
					variant="flat"
					onChange={(v: DropdownValue) => onChange(name, v)}
					value={getSelectValue(value)}
					formatOptionLabel={formatOptionLabel}
					components={{ IndicatorSeparator, DropdownIndicator, SingleValue: CustomSingleValue }}
					options={[{ value: 'all', label: 'All' }, ...options]}
					defaultValue={{ value: 'all', label: 'All' }}
					isSearchable={isSearchable}
				/>
			</DropDownContainer>
		)
	}
)

export const StyledNetworkSelect = styled(Select)`
	.react-select__control {
		padding: 5.5px 2px;
		background-color: ${(props) =>
			props.theme.colors.selectedTheme.newTheme.containers.secondary.background};
	}

	.react-select__menu {
		width: 100%;
		background-color: ${(props) =>
			props.theme.colors.selectedTheme.newTheme.containers.secondary.background};
	}
`

const StyledLabelContainer = styled(FlexDiv)`
	justify-content: flex-start;
	gap: 5px;
	color: ${(props) => props.theme.colors.selectedTheme.text.value};
`
const DropDownContainer = styled(FlexDivCol)`
	width: 100%;
	max-width: 150px;
`

export default DropdownFilter
